(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = false;
  class CoutureMotion extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.animations = [];
      this.inView = true;
      this.control = this.querySelector('[data-motion-toggle]');
      this.toggle = () => { userPaused = !userPaused; document.dispatchEvent(new Event('bf-motion-change')); };
      this.update = () => this.refresh();
      this.resize = () => { clearTimeout(this.timer); this.timer = setTimeout(this.update, 180); };
      this.visibility = () => this.conserve();
      this.control?.addEventListener('click', this.toggle);
      document.addEventListener('bf-motion-change', this.update);
      document.addEventListener('visibilitychange', this.visibility);
      reduced.addEventListener('change', this.update);
      window.addEventListener('resize', this.resize);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.conserve(); }, { rootMargin: '150px' });
      this.observer.observe(this);
      this.photo = this.querySelector('.main-photo');
      this.pointer = e => {
        if (this.isStatic || innerWidth < 900 || e.pointerType !== 'mouse') return;
        const r = this.photo.getBoundingClientRect(), x = (e.clientX-r.left)/r.width-.5, y = (e.clientY-r.top)/r.height-.5;
        this.photo.style.setProperty('--rx', `${-y*2.5}deg`);
        this.photo.style.setProperty('--ry', `${x*2.5}deg`);
        this.photo.style.setProperty('--light', `${(x+.5)*100}%`);
      };
      this.leave = () => { this.photo.style.setProperty('--rx','0deg'); this.photo.style.setProperty('--ry','0deg'); };
      this.photo?.addEventListener('pointermove', this.pointer);
      this.photo?.addEventListener('pointerleave', this.leave);
      this.refresh();
    }
    refresh() {
      this.animations.forEach(a => a.cancel());
      this.animations = [];
      this.isStatic = userPaused || reduced.matches || this.dataset.motion !== 'true' || !Element.prototype.animate;
      this.classList.toggle('static', this.isStatic);
      if (this.control) { this.control.textContent = this.isStatic ? this.control.dataset.off : this.control.dataset.on; this.control.setAttribute('aria-pressed',String(this.isStatic)); this.control.hidden = this.dataset.motion !== 'true'; }
      this.querySelectorAll('.flight-zone').forEach((zone,z) => {
        const w = zone.clientWidth, h = zone.clientHeight;
        zone.querySelectorAll('.flight').forEach((fly,i) => {
          const scale = Number(fly.dataset.scale);
          fly.style.left = `${i*32+5}%`; fly.style.top = `${i%2*12+5}px`; fly.style.transform = `scale(${scale})`;
          if (this.isStatic || (innerWidth < 600 && i > 0)) return;
          const amplitude = Math.max(0,w*.26-100), origin = i*w/3;
          const frames = Array.from({length:13},(_,n) => {
            const t = n/12*Math.PI*2;
            return { offset:n/12, transform:`translate(${origin+amplitude*(.5+.5*Math.sin(t+i))}px,${8+Math.max(0,h-(innerWidth<600?75:115))*(.5+.5*Math.sin(t*2+i*.8))}px) rotate(${Math.sin(t+.5)*13-8}deg) scale(${scale*(innerWidth<600?.8:1)})` };
          });
          fly.style.left = '0'; fly.style.top = '0';
          this.animations.push(fly.animate(frames,{duration:18000+i*3700+z*1900,iterations:Infinity,easing:'linear',delay:-i*4900}));
        });
      });
      if (!this.isStatic) this.querySelectorAll(".bf-orbit").forEach((orbit,i) => this.animations.push(orbit.animate([{transform:"rotate(-12deg)"},{transform:"rotate(12deg)"},{transform:"rotate(-12deg)"}],{duration:22000+i*6000,iterations:Infinity,easing:"ease-in-out"})));
      if (!this.isStatic) {
        this.querySelectorAll('[data-hw-ember]').forEach((node,i)=>this.animations.push(node.animate([{opacity:.65},{opacity:1},{opacity:.65}],{duration:6000+i*1200,iterations:Infinity,easing:'ease-in-out'})));
        this.querySelectorAll('[data-hw-window-glow]').forEach(node=>this.animations.push(node.animate([{opacity:.18},{opacity:.7,offset:.32},{opacity:.3,offset:.55},{opacity:.85,offset:.78},{opacity:.18}],{duration:14000,iterations:Infinity,easing:'ease-in-out'})));
        this.querySelectorAll('[data-hw-cinder]').forEach((node,i)=>{if(innerWidth<750&&i>2)return;this.animations.push(node.animate([{transform:'translate3d(0,0,0)',opacity:0},{opacity:.55,offset:.18},{opacity:.35,offset:.65},{transform:`translate3d(${i%2?18:-18}px,-180px,0)`,opacity:0}],{duration:11000+i*1300,iterations:Infinity,delay:-i*2100,easing:'ease-out'}));});
        this.querySelectorAll('[data-hw-ghost]').forEach(node=>this.animations.push(node.animate([{opacity:0,transform:'translate3d(14px,8px,0)'},{opacity:0,offset:.2},{opacity:.4,transform:'translate3d(0,-4px,0)',offset:.34},{opacity:.28,transform:'translate3d(-10px,-12px,0)',offset:.47},{opacity:0,transform:'translate3d(-28px,-22px,0)',offset:.6},{opacity:0,transform:'translate3d(-28px,-22px,0)'}],{duration:24000,iterations:Infinity,delay:-6000,easing:'ease-in-out'})));
        this.querySelectorAll('[data-hw-fog]').forEach(node=>this.animations.push(node.animate([{transform:'translateX(-4%)',opacity:.25},{transform:'translateX(4%)',opacity:.45},{transform:'translateX(-4%)',opacity:.25}],{duration:22000,iterations:Infinity,easing:'ease-in-out'})));
        this.querySelectorAll('[data-galaxy-orbit]').forEach(node=>this.animations.push(node.animate([{transform:'rotate(0deg)'},{transform:'rotate(360deg)'}],{duration:100000,iterations:Infinity,easing:'linear'})));
        this.querySelectorAll('[data-galaxy-photo]').forEach(node=>this.animations.push(node.animate([{transform:'translateY(0)'},{transform:'translateY(-8px)'},{transform:'translateY(0)'}],{duration:9000,iterations:Infinity,easing:'ease-in-out'})));
        this.querySelectorAll('[data-galaxy-spark]').forEach((node,i)=>this.animations.push(node.animate([{opacity:.45},{opacity:1},{opacity:.45}],{duration:6000+i*1800,iterations:Infinity,easing:'ease-in-out'})));
      }
      this.conserve();
    }
    conserve() { this.animations.forEach(a => { if (document.hidden || !this.inView) a.pause(); else if (!this.isStatic) a.play(); }); }
    disconnectedCallback() {
      this.animations?.forEach(a=>a.cancel()); this.observer?.disconnect(); clearTimeout(this.timer);
      this.control?.removeEventListener('click',this.toggle); this.photo?.removeEventListener('pointermove',this.pointer); this.photo?.removeEventListener('pointerleave',this.leave);
      document.removeEventListener('bf-motion-change',this.update); document.removeEventListener('visibilitychange',this.visibility); reduced.removeEventListener('change',this.update); window.removeEventListener('resize',this.resize); this.ready=false;
    }
  }
  class CoutureSelection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true; this.dialog=this.querySelector('dialog');
      this.click = e => {
        const filter = e.target.closest('[data-filter]');
        if (filter && this.contains(filter)) {
          const apply = () => { this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter))); this.querySelectorAll('[data-category]').forEach(card=>card.hidden=filter.dataset.filter!=='all'&&card.dataset.category!==filter.dataset.filter); this.count(); };
          if (document.startViewTransition && !reduced.matches) document.startViewTransition(apply); else apply();
        }
        const gallery=e.target.closest('[data-gallery-src]');
        if (gallery && this.contains(gallery)) {
          if (!this.dialog.showModal) { location.href=gallery.dataset.galleryUrl; return; }
          this.trigger=gallery; this.dialog.querySelector('h2').textContent=gallery.dataset.galleryAlt;
          const img=this.dialog.querySelector('img'); img.src=gallery.dataset.gallerySrc; img.alt=gallery.dataset.galleryAlt;
          this.dialog.querySelector('[data-gallery-link]').href=gallery.dataset.galleryUrl; this.dialog.showModal();
        }
        if (e.target.closest('[data-gallery-close]')) this.dialog.close();
      };
      this.restore=()=>this.trigger?.focus(); this.addEventListener('click',this.click); this.dialog.addEventListener('close',this.restore); this.count();
    }
    count() { const n=this.querySelectorAll('[data-category]:not([hidden])').length, status=this.querySelector('[data-filter-status]'); if(status)status.textContent=`${n} ${n===1?this.dataset.one:this.dataset.many}`; }
    disconnectedCallback() { this.removeEventListener('click',this.click); this.dialog?.removeEventListener('close',this.restore);this.ready=false; }
  }
  if (!customElements.get('bf-motion')) customElements.define('bf-motion',CoutureMotion);
  if (!customElements.get('bf-selection')) customElements.define('bf-selection',CoutureSelection);

  class CoutureProductCard extends HTMLElement {
    connectedCallback() {
      if(this.onColor) return;
      this.onColor=e=>{
        const choice=e.target.closest('[data-color-choice]');
        if(!choice||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
        const photo=this.querySelector('.bf-card-primary');
        if(!photo) return;
        e.preventDefault();
        this.querySelectorAll('[data-color-choice]').forEach(dot=>dot.removeAttribute('aria-current'));
        choice.setAttribute('aria-current','true');
        this.dataset.colorSelected='true';
        this.querySelectorAll('[data-card-link]').forEach(a=>a.href=choice.href);
        const caption=this.querySelector('[data-color-caption]');
        if(caption) caption.textContent=choice.dataset.color;
        const price=this.querySelector('[data-card-price]');
        const regular=document.createElement('span');regular.textContent=choice.dataset.price;
        price.replaceChildren(regular);
        if(choice.dataset.compare){const compare=document.createElement('s');compare.textContent=choice.dataset.compare;price.append(compare);}
        if(choice.dataset.image){photo.removeAttribute('srcset');photo.src=choice.dataset.image;photo.alt=this.querySelector('h3').textContent.trim()+' · '+choice.dataset.color;}
      };
      this.addEventListener('click',this.onColor);
    }
    disconnectedCallback(){this.removeEventListener('click',this.onColor);this.onColor=null;}
  }
  if(!customElements.get('bf-product-card')) customElements.define('bf-product-card',CoutureProductCard);

})();
